import { Box, HStack, Text } from "@chakra-ui/layout";
import { Trans } from "@lingui/macro";
import { CreditAccountItem } from "@src/components/modules/expenses/Create/components/credit-accounts-card/components/credit-account-item";
import type { ExpenseCreditAccountsCardStore } from "@src/components/modules/expenses/Create/components/credit-accounts-card/store";
import { AddButton, Card } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";

type Props = {
  store: ExpenseCreditAccountsCardStore;
};

export const CreditAccountsCard = observer(function CreditAccountsCard({
  store,
}: Props) {
  return (
    <Card w="full">
      <Card.Section>
        <HStack>
          <Text as="h2" mr="2" fontSize="xl">
            <Trans>Credit Accounts</Trans>
          </Text>
          <AddButton onClick={() => store.addItem()} />
        </HStack>
        <Box mt="4">
          {store.items.map((item, index) => (
            <CreditAccountItem
              key={item.$.id.value}
              item={item}
              itemIndex={index}
              store={store}
            />
          ))}
        </Box>
      </Card.Section>
    </Card>
  );
});
